import { statusLabel, statusTone } from "../utils/format";

export function StatusPill({ status }: { status?: string | null }) {
  return <span className={`status-pill status-pill--${statusTone(status)}`}>{statusLabel(status)}</span>;
}
